import React, { useState, useEffect } from "react";
import "../remixicons/fonts/remixicon.css";
import "../bootstrap.min.css";
import "../App.css";
import copyIcon from "../images/copyIcon.png";
import eligible from "../images/eligible.png";
import tier2 from "../images/tier2.png";
import stakingImage from "../images/stakingImage.png";
import distribution from "../images/distributionTiers.png";
import dextool from "../images/dextools-transformed.png";
import logo from "../images/logo.webp";
function Staking({
  stakeTokens,
  unstakeTokens,
  getTierAndEligibility,
  getStakeDetails,
  address,
}) {
  const [amount, setAmount] = useState();
  const [accountAddress, setAccountAddress] = useState();
  const [tierAndeligiblity, setTierAndeligiblity] = useState();
  const [stakeDetails, setStakeDetails] = useState();
  const [isUnstakeHighlighted, setIsUnstakeHighlighted] = useState(false);
  const [days, setDays] = useState({});
  const [hours, setHours] = useState({});
  const handleStakeClick = () => {
    setIsUnstakeHighlighted(false);
  };

  const handleUnstakeClick = () => {
    setIsUnstakeHighlighted(true);
  };

  const copyToClipboard = () => {
    const textToCopy = document.getElementById("textToCopy").textContent;
    navigator.clipboard.writeText(textToCopy);
    alert("Text copied to clipboard!");
  };

  const handleChange = (event) => {
    const value = event.target.value;
    let parsedAmount = parseInt(value) * parseInt(1000000000);
    setAmount(parsedAmount);
  };

  async function getAddress() {
    setAccountAddress(await address?.getAddress());
  }

  async function getDetails() {
    try {
      setStakeDetails(await getStakeDetails());
      setTierAndeligiblity(await getTierAndEligibility());
    } catch (error) {}
  }

  async function calculateTimeLeft() {
    const stakeTime = await stakeDetails?.stakeTime?.toString();
    const millisecondsInADay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
    const newDate = new Date(
      stakeTime * 1000 + 7 * parseInt(millisecondsInADay)
    );
    
    const currentDate = new Date();
    const timeDifferenceInMilliseconds = newDate - currentDate;
    const days = Math.floor(
      timeDifferenceInMilliseconds / (24 * 60 * 60 * 1000)
    );
    const hours = Math.floor(
      (timeDifferenceInMilliseconds % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
    );
    if(days >= 0){

      setDays(days);
      setHours(hours);
    }
  }

  useEffect(() => {
    getAddress();
    getDetails();
    calculateTimeLeft();
  }, [getDetails, calculateTimeLeft]);

  return (
    <div>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          {/* <!-- Icons on the left --> */}
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <span className="nav_div">
                <a href="https://twitter.com/blastersgg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-twitter"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                  </svg>
                </a>
              </span>

              <span className="nav_div">
                <a href="https://t.me/blastersggportal">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="16"
                    height="16"
                    viewBox="0,0,256,256"
                    style={{ fill: "#000000" }}
                  >
                    <g
                      fill="#ffffff"
                      fillRule="nonzero"
                      stroke="none"
                      strokeWidth="1"
                      strokeLinecap="butt"
                      strokeLinejoin="miter"
                      strokeMiterlimit="10"
                      strokeDasharray=""
                      strokeDashoffset="0"
                      fontFamily="none"
                      fontWeight="none"
                      fontSize="none"
                      textAnchor="none"
                      style={{ mixBlendMode: "normal" }}
                    >
                      <g transform="scale(5.33333,5.33333)">
                        <path d="M5.83,23.616c12.568,-5.529 28.832,-12.27 31.077,-13.203c5.889,-2.442 7.696,-1.974 6.795,3.434c-0.647,3.887 -2.514,16.756 -4.002,24.766c-0.883,4.75 -2.864,5.313 -5.979,3.258c-1.498,-0.989 -9.059,-5.989 -10.7,-7.163c-1.498,-1.07 -3.564,-2.357 -0.973,-4.892c0.922,-0.903 6.966,-6.674 11.675,-11.166c0.617,-0.59 -0.158,-1.559 -0.87,-1.086c-6.347,4.209 -15.147,10.051 -16.267,10.812c-1.692,1.149 -3.317,1.676 -6.234,0.838c-2.204,-0.633 -4.357,-1.388 -5.195,-1.676c-3.227,-1.108 -2.461,-2.543 0.673,-3.922z"></path>
                      </g>
                    </g>
                  </svg>
                </a>
              </span>

              <span className="nav_div">
                <a href="https://etherscan.io/token/0xab98093c7232e98a47d7270ce0c1c2106f61c73b">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 123 123"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M25.79 58.4149C25.7901 57.7357 25.9244 57.0633 26.1851 56.4361C26.4458 55.809 26.8278 55.2396 27.3092 54.7605C27.7907 54.2814 28.3619 53.9021 28.9903 53.6444C29.6187 53.3867 30.2918 53.2557 30.971 53.2589L39.561 53.2869C40.9305 53.2869 42.244 53.831 43.2124 54.7994C44.1809 55.7678 44.725 57.0813 44.725 58.4509V90.9309C45.692 90.6439 46.934 90.3379 48.293 90.0179C49.237 89.7962 50.0783 89.262 50.6805 88.5019C51.2826 87.7418 51.6102 86.8006 51.61 85.8309V45.5409C51.61 44.1712 52.154 42.8576 53.1224 41.889C54.0908 40.9204 55.4043 40.3762 56.774 40.3759H65.381C66.7506 40.3762 68.0641 40.9204 69.0325 41.889C70.0009 42.8576 70.545 44.1712 70.545 45.5409V82.9339C70.545 82.9339 72.7 82.0619 74.799 81.1759C75.5787 80.8462 76.2441 80.2941 76.7122 79.5886C77.1803 78.8832 77.4302 78.0555 77.431 77.2089V32.6309C77.431 31.2615 77.9749 29.9481 78.9431 28.9797C79.9113 28.0113 81.2245 27.4672 82.5939 27.4669H91.201C92.5706 27.4669 93.884 28.0109 94.8525 28.9794C95.8209 29.9478 96.365 31.2613 96.365 32.6309V69.3399C103.827 63.9319 111.389 57.4279 117.39 49.6069C118.261 48.4717 118.837 47.1386 119.067 45.7267C119.297 44.3148 119.174 42.8678 118.709 41.5149C115.931 33.5227 111.516 26.1983 105.745 20.0105C99.974 13.8228 92.9749 8.90785 85.1955 5.58032C77.4161 2.2528 69.0277 0.585938 60.5671 0.686416C52.1065 0.786893 43.7601 2.6525 36.062 6.16383C28.3638 9.67517 21.4834 14.7549 15.8611 21.078C10.2388 27.401 5.99842 34.8282 3.41131 42.8842C0.824207 50.9401 -0.0526487 59.4474 0.836851 67.8617C1.72635 76.276 4.36263 84.4119 8.57696 91.7489C9.31111 93.0145 10.3912 94.0444 11.6903 94.7175C12.9894 95.3906 14.4536 95.679 15.911 95.5489C17.539 95.4059 19.566 95.2029 21.976 94.9199C23.0251 94.8008 23.9937 94.2999 24.6972 93.5126C25.4008 92.7253 25.7901 91.7067 25.791 90.6509L25.79 58.4149Z" />
                    <path d="M25.6021 110.51C34.6744 117.11 45.3959 121.072 56.5802 121.957C67.7646 122.841 78.9757 120.615 88.9731 115.523C98.9705 110.431 107.364 102.673 113.226 93.1068C119.087 83.5405 122.188 72.539 122.185 61.3197C122.185 59.9197 122.12 58.5347 122.027 57.1577C99.808 90.2957 58.7831 105.788 25.604 110.505" />
                  </svg>
                </a>
              </span>

              <span className="nav_div" style={{ paddingLeft: "0" }}>
                <a href="https://www.dextools.io/app/en/ether/pair-explorer/0x6adb403912608ffffd8fe623a7db35f59e4b4f43">
                  <img src={dextool} width={32} height={32} />
                </a>
              </span>
            </li>
          </ul>
          <div className="navbar-logo mx-auto  nav_logo">
            {/* <h1>B</h1> */}

            <img src={logo} width={33} height={43} />
          </div>

          <div id="navbarNav">
            <ul className="navbar-nav">
              <button className="play_btn" style={{ textAlign: " center" }}>
                PLAY
              </button>
            </ul>
          </div>
        </div>
      </nav>
      <section className="staking">
        <div className="staking_scd_div">
          <div className="img_div">
            <img src={stakingImage} alt="" />
          </div>

          <div className="countdown_div">
            <p className="countdown">Countdown</p>
          </div>

          <div className="payout_main_div">
            <div className="staking_payout_div">
              <h6>TIME TO NEXT PAYOUT...</h6>
              <div className="staking_payout_2nddiv">
                <h1>Coming Soon</h1>
              </div>
            </div>
          </div>

          <div className="payout_point_div">
            <ul>
              <li>Payouts are sent every 7 days</li>
              <li>
                You must stake for 7 days in order to become{" "}
                <span style={{ textDecoration: " underline" }}>eligible</span>{" "}
                to all future payouts-until you unstake
              </li>
            </ul>
          </div>

          <div className="your_wallet_div">
            <p>Your Wallet</p>
          </div>
          <div className="row address_div">
            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-6 ">
              <p className="address_div_heading">ADDRESS</p>
              <div className="address_2nddiv">
                <div id="textToCopy">
                  {`${accountAddress?.slice(0, 7)}` +
                    "..." +
                    `${accountAddress?.slice(-5)}`}
                </div>
                <div className="copy_icon">
                  <img src={copyIcon} onClick={() => copyToClipboard} />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-6">
              <p className="address_div_heading">{} BLAST STAKED</p>
              <div className="address_2nddiv1">
                <div>
                  {stakeDetails
                    ? parseInt(stakeDetails?.amountStaked?.toString()) /
                      parseInt(1000000000)
                    : 0}
                </div>
                {/* <div>f</div> */}
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-6 wallet_buttons">
              <div>
                <p className="address_div_heading">TIER</p>
                <div>
                  {/* <img className="address_div_img" src={tier2} alt="" /> */}
                  {tierAndeligiblity ? (
                    tierAndeligiblity[0] && stakeDetails?.amountStaked?.toString() ? (
                      <button className="tierBtn">
                        {tierAndeligiblity[0]}
                      </button>
                    ) : (
                      // <button className="tierBtn"></button>
                      ""
                    )
                  ) : (
                    // <button className="tierBtn"></button>
                    ""
                  )}
                </div>
              </div>

              <div>
                <p className="address_div_heading">ELIGIBLE?</p>
                <div>
                  {tierAndeligiblity ? (
                    tierAndeligiblity[1] === true ? (
                      <button className="eligible">ELIGIBLE</button>
                    ) : (
                      <button className="eligible-timer">
                        {`${days}D,` + `${hours}H`}
                      </button>
                    )
                  ) : (
                    // <button className="eligible-timer"></button>
                    ""
                  )}
                </div>
              </div>
            </div>
            {/* <div className="col-lg-3 col-md-2 col-sm-6 col-xs-6">
              
            </div> */}

            <div className="stake_div">
              <div className="stake_btn_div">
                <button
                  className={`stake_btn ${
                    !isUnstakeHighlighted ? "highlighted" : "dull"
                  }`}
                  id="stakeButton"
                  onClick={() => handleStakeClick() && handleStakeClick}
                  disabled={!isUnstakeHighlighted}
                >
                  STAKE
                </button>

                <button
                  className={`unstake_btn ${
                    isUnstakeHighlighted ? "highlighted" : "dull"
                  }`}
                  id="unstakeButton"
                  onClick={() => handleUnstakeClick() && handleStakeClick}
                  disabled={isUnstakeHighlighted}
                >
                  UNSTAKE
                </button>
              </div>
              {/* <div id="textToCopy">Text to be copied</div>
              <button onClick={copyToClipboard}>Copy to Clipboard</button> */}

              <div className="search_main_div">
                <div>
                  <p>Amount</p>
                </div>
                <div
                  className="row stake-div"
                  style={{ textAlign: "center", alignItems: "center" }}
                >
                  <div className="col-lg-9">
                    <input
                      type="text"
                      width="100%"
                      required
                      onChange={handleChange}
                    />
                  </div>
                    
                  <div className="col-lg-3  stake_icon" style={{ textAlign: "left" }}>
                    
                    {/* <img className="stake_2nd_btn" src={stakeButton}/> */}
                     <div>
                      <span className="stake_btn_text">Click once and wait 5-10s</span>
                      </div> 
                    {isUnstakeHighlighted ? (
                      <button
                        className="stake_2nd_btn"
                        onClick={() => unstakeTokens && unstakeTokens(amount)}
                      >
                        UNSTAKE
                      </button>
                    ) : (
                      <button
                        className="stake_2nd_btn"
                        onClick={() => stakeTokens && stakeTokens(amount)}
                      >
                        STAKE
                      </button>
                    )}
                  </div>
                  
                </div>
              </div>
              <div className="distribution_img">
                <img src={distribution} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Staking;
